/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { get } from "lodash-es";
import { classnames } from "../../utils/text";
import Icon from "../Icon";
import Profile from "../Profile";
import { dateToViewFormat } from "../../utils/date";
import { getTaskByType, taskDetail } from "../../utils/task";

import timerIcon from "../../assets/images/icon/timer-icon.svg";
import { useHistory } from "react-router-dom";
import { readNotifications } from "../../apis/notification";
import { getUnreadNotificationCount, setProfile } from "../../store/actions";
import { useDispatch } from "react-redux";
import systemAlert from "../../utils/systemAlert";
import { viewLoading } from "../../utils/loading";
import { getCompanyToken } from "../../apis/companies/companies";
import { isNumber } from "lodash";

const NOTICE_TYPES = [
  "WORK_HISTORY",
  "NOTICE",
  "JOIN_COMPANY_REQUEST",
  "BANK_TRANS",
];

const NotificationItem = (props) => {
  const {
    // notificationIdx, 
    messageId,
    type,
    data,
    isRead: _isRead,
    title: _title,
    message,
    sendEmployeeIdx,
    sentTime,
    employee,
  } = props;
  // TASK 인경우
  const [taskType, setTaskType] = useState(null);
  const [isRead, setIsRead] = useState(_isRead);

  const [icon, setIcon] = useState(null);
  const [title, setTitle] = useState(_title);
  const history = useHistory();
  const dispatch = useDispatch();



  useEffect(() => {
    if (type === "WORK_TICKET") {
      const taskType = getTaskByType(get(data, 'workticketType', ''));
      if (taskType) {
        setTaskType(taskType);
      }
    }
    else if (type === "WORK_HISTORY") {
      setIcon(timerIcon);
    }
  }, []);

  useEffect(() => {
    if (taskType) {
      setIcon(taskType.icon);
      setTitle(taskType.label);
    }
  }, [taskType]);

  const itemClick = async () => {
    // WORK_HISTORY (출퇴근) / WORK_TICKET (업무 티켓) / APPROVAL (결재) / NOTICE (공지) / JOIN_COMPANY_REQUEST (직원의 회사 등록 요청) / JOIN_COMPANY_CONFIRM (회사의 직원 등록 요청 승인)
    if (!isRead) {
      await readNotifications([messageId]);
      dispatch(getUnreadNotificationCount());
      setIsRead(true);
    }
    // TASK 일떄 상세 화면 노출
    if (type === "WORK_TICKET") {
      taskDetail({
        type: data.workticketType,
        approvalTargetIdx: data.workticketIdx,
      });
    }
    // 워크 히스토리 일떄 워크히스토리 노출
    else if (type === "WORK_HISTORY") {
      history.push('/attendance/management');
    }
    // 결재 요청
    else if (type === "APPROVAL") {

    }
    // 공지
    else if (type === "NOTICE") {
      history.push('/dashboard?tab=REMINDER_BOARD');
    }
    // 직원 요청
    else if (type === "JOIN_COMPANY_REQUEST") {
      history.push('/person/organization?tab=EMPLOYEE_REQUEST');
    }
    // 회사의 직원 등록 요청 승인
    else if (type === "JOIN_COMPANY_CONFIRM") {

    } else if (type === "COUNSELING") {
      if (data.path === "tax_counseling") {
        // data.companyIdx
      } else if (data.path === "labor_counseling") {

      }
      //console.log("COUNSELING: ", messageId, type, data, isRead, title, message, sendEmployeeIdx, sentTime)
      //console.log("props: ", props)
    } else if (type === "COMMUNITY") {
      if (data.path === "tax_community") { // 세무담당자 - 커뮤니티

      } else {

      }
    } else if (type === "BANK_TRANS") {
      history.push('/funds/accout-detail?tab=use-confirm');

    } else if (type === "TAX_CONSULTING") {
      data.categoryIdx && history.push(`/tax-portal/tax-consulting/?categoryIdx=${data.categoryIdx}${data.boardIdx && isNumber(data.boardIdx) ? `&boardIdx=${data.boardIdx}` : ""}`);
    } else {
    }
  };


  const handleChangeCompany = () => {
    if (employee?.managerCompanyIdx !== employee.companyIdx && NOTICE_TYPES.includes(type)) {
      systemAlert("관리회사 접속 중엔 알람 바로가기를 실행할 수 없습니다.\n세무회사로 접속하시겠습니까?", {
        buttons: [
          { label: "취소", color: "text" },
          {
            label: "접속", onClick: async () => {
              viewLoading(true);
              getCompanyToken({ companyIdx: employee.managerCompanyIdx, type: employee.type })
                .then(async () => {
                  dispatch(setProfile());
                  await itemClick();
                })
                .catch((err) => {
                  systemAlert(get(err, 'response.data.message') || err.response);
                })
                .finally(() => {
                  viewLoading(false);
                });
            }
          }
        ]
      });
    }
  };
  return (
    <div
      className={classnames(
        'notification-item',
        `notification-item-${type}`,
        { 'is-read': isRead }
      )}
      onClick={employee?.managerCompanyIdx !== employee.companyIdx ? handleChangeCompany : itemClick}
    >
      <div className="notification-item-inner">
        {icon &&
          <div className="notification-item-icon">
            <Icon
              className={classnames({
                'red': message.indexOf('지각') > -1 || message.indexOf('조퇴') > -1,
              })}
              src={icon}
            />
          </div>
        }
        <div className='notification-item-contents'>
          {title &&
            <p className="title">
              {title}
            </p>
          }
          {
            message &&
            <p className="content">
              {message}
            </p>
          }
        </div>
        <div className="notification-item-info">
          {
            sendEmployeeIdx &&
            <Profile
              employeeIdx={sendEmployeeIdx}
            />
          }
          {
            sentTime &&
            <p className="date">{dateToViewFormat(sentTime, 'MM.DD HH:mm')}</p>
          }
        </div>
      </div>
    </div>
  );
};

export default NotificationItem;
